export enum InvestmentActivity {
    Valuation = "Valuation",
    Documents = "Documents",
    Tearsheets = "Tearsheet",
    Review = "Review",
    Meeting = "Meeting",
    Others = "Others"
}


export enum InvestmentActivityFileType {
    IC_Memo = 'IC_Memo',
    Legal = 'Legal',
    Technical_Materials = 'Technical_Materials'
}